<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="修改密码"
    :visible.sync="dialogFormVisible"
    @closed="closed"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="新密码" :label-width="formLabelWidth" prop="userPwd">
        <el-input
          type="password"
          v-model="editForm.userPwd"
          placeholder="请输入新密码"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { mapGetters } from 'vuex';
import { resetPasswordApi } from '@/api/user.js';
// import { changeStatusApi } from '@/api/introduce';
// import { getToken } from '@/utils/token.js'
export default {
  name: 'ChangePassword',
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      userOptions: [],
      loading: false,
      // 编辑表单
      editForm: {
        userId: '',
        userPwd: '',
      },
      // 表单的验证规则
      editRules: {
        userPwd: [{ required: true, message: '请输入密码！', trigger: 'blur' }],
      },
    };
  },

  mounted() {},
  methods: {
    // 提交按钮
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return;
          resetPasswordApi(this.editForm).then((res) => {
            if (res.code == 200) {
              this.$message.success('修改成功！');
              this.dialogFormVisible = false;
              this.closed();
            } else {
              this.$message.error(this.res.message);
            }
          });
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 关闭时的回调
    closed() {
      this.$refs.editForm.resetFields();
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
